import React from "react";
import { Box, Typography, Link } from "@mui/material";

const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                py: 2,
                px: 3,
                mt: "auto",
                position: "relative",
                backgroundColor: "primary.main",
                color: "white",
                textAlign: "center",
                zIndex:100
            }}
        >
            <Typography variant="body2">
                © 2024{" "}
                <Link
                    href="https://www.naturalpackersandmovers.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    color="inherit"
                    underline="none"
                >
                    Natural Packers and Movers
                </Link>
                . All rights reserved.{" "}
                <Link
                    href="/privacy-policy"
                    underline="hover"
                    color="inherit"
                >
                    Privacy Policy
                </Link>
            </Typography>
        </Box>
    );
};

export default Footer;
